<template>
  <div id="app">
    <Layout>
      <template #left>
        <div class="aside">
          <SiteAside></SiteAside>
        </div>
      </template>
      <template #main>
        <div class="main">
          <RouterView />
        </div>
      </template>
      <!-- <template #right>
        <div class="right">
          右边区域
        </div>
      </template> -->
    </Layout>
    <Totop></Totop>
  </div>
</template>

<script>
import SiteAside from './components/SiteAside';
import Layout from './components/Layout';
import Totop from './components/Totop';
export default {
  name: 'App',
  components: {
    SiteAside,
    Layout,
    Totop,
  },
}
</script>

<style lang="less" scoped>
@import url(./type/reset.less);

// 错误弹出css
// .errow-container {
//   position: relative;
//   width: 500px;
//   height: 500px;
//   border: 1px solid;
//   margin: 0 auto;
// }


#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.aside {
  overflow: hidden;
  width: 350px;
  height: 100%;
}

.site-aside-container {
  width: 100%;
  height: 100%;
}

.main {
  position: relative;
  width: 100%;
  height: 100%;
  background: #eee;
}
</style>
